<template>
  <!-- CORRECTIF GLOBAL WINDOWS : pt-0 mt-0 et isolation de la section pour supprimer le grand vide -->
     <!-- 4. FIX DÉFINITIF WINDOWS : INTÉGRATION DE LA SECTION DES ÉVÉNEMENTS DANS LE TEMPLATE -->
    <section class="max-w-screen-xl mx-auto px-4 pt-6 pb-12">
      
      <!-- En-tête sans marge haute parasite -->
      <div class="max-w-screen-sm mb-6 space-y-2 mt-0 pt-0 text-left">
        <h2 id="evens" class="text-xl md:text-2xl font-extrabold tracking-tight text-slate-900 dark:text-white flex items-center gap-2.5">
          <svg class="w-5 h-5 text-indigo-600 dark:text-indigo-400 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
          </svg>
          <span>Prochains événements / Upcoming events</span>
        </h2>
        <div class="w-24 h-1.5 bg-indigo-100 dark:bg-slate-800 rounded-full overflow-hidden flex">
          <div class="bg-indigo-600 w-1/3 h-full"></div>
          <div class="bg-amber-500 w-2/3 h-full"></div>
        </div>
      </div>

    <div class="bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700/60 rounded-2xl shadow-sm overflow-hidden p-2 md:p-4">
        <div class="flow-root">
          <ul role="list" class="divide-y divide-slate-100 dark:divide-slate-700/50">
            
            <!-- Boucle dynamique sur les événements -->
            <li 
              v-for="(evenement, index) in listeEvenements" 
              :key="index" 
              class="py-5 sm:py-6 first:pt-2 last:pb-2 group hover:bg-slate-50/50 dark:hover:bg-slate-700/20 px-4 rounded-xl transition-colors duration-200"
            >
              <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                
                <!-- Date de l'événement -->
                <div class="flex-shrink-0 min-w-[150px] text-left">
                  <p class="text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">
                    Date
                  </p>
                  <p class="text-sm font-semibold text-slate-800 dark:text-slate-200 mt-0.5">
                    {{ evenement.date }}
                  </p>
                </div>
                
                <!-- Contenu de la mission (Bordure colorée épurée) -->
                <div class="flex-1 min-w-0 text-left">
                  <div class="border-l-4 border-indigo-500 dark:border-indigo-400 pl-4 py-1">
                    <h4 class="text-base font-bold text-slate-900 dark:text-white tracking-tight group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">
                      {{ evenement.titre }}
                    </h4>
                    <p class="text-sm text-slate-500 dark:text-slate-400 font-light mt-0.5">
                      Destination : <span class="font-medium text-slate-700 dark:text-slate-300">{{ evenement.destination }}</span>
                    </p>
                  </div>
                </div>
                
                <!-- Bouton d'action interactif -->
                <div class="flex items-center justify-end">
                  <button 
                    @click="evenement.action()" 
                    type="button" 
                    class="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-indigo-50 text-indigo-600 hover:bg-indigo-600 hover:text-white dark:bg-slate-700 dark:text-indigo-400 dark:hover:bg-indigo-500 dark:hover:text-white focus:ring-4 focus:ring-indigo-100 dark:focus:ring-indigo-950 transition-all duration-200 active:scale-95"
                    :title="`See mission to ${evenement.destination}`"
                  >
                    <svg class="w-4 h-4 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
                    </svg>
                    <span class="sr-only">View Mission Details</span>
                  </button>
                </div>
                
              </div>
            </li>

          </ul>
        </div>
      </div>



    </section>

</template>

<script>
export default {
  name: 'MissionGuinee',
  data() {
    return {
      listeEvenements: [
        {
          date: "13 Octobre 2026",
          titre: "Mission économique belge",
          destination: "Guinée (Conakry)",
          action: () => this.MissionGuinnee()
        }
      ]
    }
  },
  methods: {
    MissionGuinnee() {
      // FIX : Remplacement par le vrai chemin de route déployé pour éviter le bug d'affichage
      this.$router.push("/mission-economique-conakry");
    }
  }
}
</script>
